import * as React from "react";
import { forwardRef } from "react";
const LogoSberLogisticSVG = (props, ref) => React.createElement("svg", { width: 32, height: 32, fill: "none", viewBox: "0 0 32 32", ref: ref, ...props },
    React.createElement("path", { fill: "#319738", d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16" }),
    React.createElement("path", { fill: "#fff", d: "m15.538 4.68-3.47 1.988 9.743 5.943.013 12.094 3.471-1.989-.014-12.093z" }),
    React.createElement("path", { fill: "#fff", d: "m8.605 8.518-3.471 1.989 9.743 5.942.014 12.094 3.47-1.989-.013-12.093z" }),
    React.createElement("path", { fill: "#fff", d: "m8.365 16.296.005 4.031 3.475 2.043-.005-4.031z" }));
const ForwardRef = forwardRef(LogoSberLogisticSVG);
export default ForwardRef;
//# sourceMappingURL=LogoSberLogistic.js.map